import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const TermsPage = () => {
  const { t } = useLanguage();
  const c = t('legal.termsContent') || {};

  const sections = [
    { title: c.s1t, text: c.s1 },
    { title: c.s2t, text: c.s2 },
    { title: c.s3t, text: c.s3 },
    { title: c.s4t, text: c.s4 },
    { title: c.s5t, text: c.s5, hasLicensingLink: true },
    { title: c.s6t, text: c.s6 },
    { title: c.s7t, text: c.s7 },
    { title: c.s8t, text: c.s8 },
    { title: c.s9t, text: c.s9 },
    { title: c.s10t, text: c.s10, hasEmail: true },
  ];

  return (
    <div className="min-h-screen pt-24" data-testid="terms-page">
      <div className="container-custom py-12 max-w-4xl">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/50 hover:text-white mb-8" data-testid="terms-back-link">
          <ArrowLeft className="w-4 h-4" />{t('legal.backToHome')}
        </Link>
        <h1 className="text-4xl font-bold mb-2" data-testid="terms-title">{t('legal.termsTitle')}</h1>
        <p className="text-white/40 text-sm mb-8">{t('legal.lastUpdated')}</p>
        <div className="prose-legal space-y-8">
          {sections.map((s, i) => (
            <section key={i}>
              <h2 className="text-xl font-semibold text-[#E8720C] mb-3">{s.title}</h2>
              <p className="text-white/60 leading-relaxed">
                {s.text}
                {s.hasLicensingLink && (
                  <> <Link to="/licensing" className="text-[#E8720C] hover:underline">{t('legal.termsTitle')}</Link></>
                )}
                {s.hasEmail && (
                  <> <a href="mailto:support@ogmusicgroup.com" className="text-[#E8720C] hover:underline">support@ogmusicgroup.com</a>.</>
                )}
              </p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
